export const EMAIL_CAPTURE_RESPONSE = 'EMAIL_CAPTURE_RESPONSE';